import { TimeSlotAvailability, TimeSlotButton, TimeSlotFlag, TimeSlotValue } from './TimeSlot.styles'

const FLAG_LANGUAGES = ['pl', 'en'] as const

interface TimeSlotProps {
  time: string
  availability: number
  active?: boolean
  language?: string | null
  onClick?: () => void
}

const TimeSlot = ({ time, availability, active, language, onClick }: TimeSlotProps) => {
  const flagCode = language && (FLAG_LANGUAGES as readonly string[]).includes(language) ? language : null
  const soldOut = availability <= 0

  return (
    <TimeSlotButton type="button" active={active} disabled={soldOut} soldOut={soldOut} onClick={onClick}>
      <TimeSlotValue>
        {flagCode && <TimeSlotFlag src={`/img/langs/${flagCode}.svg`} alt={flagCode} />}
        {time}
      </TimeSlotValue>
      <TimeSlotAvailability>({availability})</TimeSlotAvailability>
    </TimeSlotButton>
  )
}

export default TimeSlot
